import { render, staticRenderFns } from "./InfoLock.vue?vue&type=template&id=549c4482&scoped=true"
import script from "./InfoLock.vue?vue&type=script&lang=js"
export * from "./InfoLock.vue?vue&type=script&lang=js"
import style0 from "./InfoLock.vue?vue&type=style&index=0&id=549c4482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c4482",
  null
  
)

export default component.exports